import {
  shouldShowPortageBanner,
  type PortageAffiliationBannerData,
  type PortageCompanyBannerData,
} from '@/components/portage/PortageInvitationBanner'

export interface PortageAffiliationPendingFreelancer {
  is_portage_awaiting?: boolean
  portage_company?: PortageCompanyBannerData | null
  portage_affiliation?: PortageAffiliationBannerData | null
}

/**
 * True tant que l'affiliation portage n'est pas confirmée (bandeau d'invitation actif).
 */
export function isPortageAffiliationPending(
  freelancer: PortageAffiliationPendingFreelancer | null | undefined
): boolean {
  if (!freelancer) return false
  if (freelancer.is_portage_awaiting === true) return true
  return shouldShowPortageBanner(freelancer.portage_company, freelancer.portage_affiliation)
}
